import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const PACK_THUMB = 'https://cdn.magicpatterns.com/uploads/o6EQirRZHassHc8uGWL9hp/0939a34e-f34e-4a6d-b780-4e1de598f781.webp';
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6500;
const GAP_MS = 10000;
const EASE = [0.23, 1, 0.32, 1] as const;
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer = 0;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentPurchases.length);
      }, VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  const purchase = recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 w-[19.5rem] max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6 sm:w-[21rem]" data-id="element-176" data-mp="1z7oyatzfi9a9">
      <AnimatePresence data-id="element-177" data-mp="285qvszjyejss">
        {visible && !dismissed && <motion.div key={`${purchase.name}-${index}`} initial={{
        opacity: 0,
        x: -28,
        scale: 0.97
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -20,
        scale: 0.98
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="pointer-events-auto relative overflow-hidden rounded-2xl bg-navy pl-1.5 shadow-[0_22px_45px_-18px_rgba(22,33,44,0.75)] ring-2 ring-tangerine" data-id="element-178" data-mp="1bgjhabhr5ayd">
            <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5 bg-tangerine" data-id="element-179" data-mp="rq6buswf6tlx" />

            <div className="flex items-center gap-3 py-3 pl-3 pr-9" data-id="element-180" data-mp="2017wly4q4pye">
              <img src={PACK_THUMB} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-white object-contain p-1" data-id="element-181" data-mp="1v2y11mf37nc9" />

              <div className="min-w-0" data-id="element-182" data-mp="28wfin1o7qpzn">
                <span className="inline-flex items-center gap-1 rounded-full bg-tangerine px-2 py-0.5 text-[9px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-183" data-mp="24s7wnc953o54">
                  <span className="relative flex h-1.5 w-1.5" data-id="element-184" data-mp="1h4zydea4pfcl">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" data-id="element-185" data-mp="1c5n4i9kub80i" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-white" data-id="element-186" data-mp="1q1qu1pkrqs6n" />
                  </span>
                  Acquisto ora
                </span>

                <p className="mt-1.5 truncate text-[13px] font-bold leading-tight text-white" data-id="element-187" data-mp="31hfgmfu41p6x">
                  {purchase.name} da {purchase.city}
                </p>
                <p className="mt-0.5 flex items-center gap-1 truncate text-[11px] text-white/65" data-id="element-188" data-mp="350eiut338rfj">
                  <BadgeCheckIcon className="h-3.5 w-3.5 shrink-0 text-ochre" aria-hidden="true" data-id="element-189" data-mp="39318cncae09k" />
                  Ha preso il pack ·{' '}
                  <span className="font-semibold text-ochre" data-id="element-190" data-mp="301bhpjq8b5cu">
                    {purchase.minutesAgo} min fa
                  </span>
                </p>
              </div>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi la notifica" className="absolute right-1.5 top-1.5 inline-flex h-6 w-6 items-center justify-center rounded-full text-white/50 transition-colors duration-150 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-tangerine" data-id="element-191" data-mp="3sr0ibvz113dx">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-192" data-mp="fcno24099mfl" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}